import * as prismic from "@prismicio/client";

const endpoint = prismic.getRepositoryEndpoint("ohio-squeeze");
const accessToken =
  "MC5hSUtFeXhFQUFDQUF5MU12.77-977-9MDMS77-977-977-9CO-_vTACOO-_vX0u77-977-9eXNbV--_vVTvv71kC--_vTLvv70KLw"; // Set an access token
const routes = [];

const client = prismic.createClient(endpoint, { routes, accessToken });

export default client;
